import { gql } from '@apollo/client'

export const BASE_ADDRESS_FRAGMENT = gql`
  fragment BaseAddress on BaseAddressInterface {
    city
    countryIsoCode
    stateIsoCode
    zipCode
  }
`
